import React, { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { toast } from 'react-toastify';
import './DatePicker.css';
import { TextConstants } from '../../Constants/Constants';

const DatePicker = ({ onSubmit, onCancel }) => {
  const today = new Date(); 
  const defaultState = [
    {
      startDate: today,
      endDate: today,
      key: 'selection',
    },
  ];

  const [state, setState] = useState(defaultState);

  const handleDateChange = (item) => {
    const { startDate, endDate } = item.selection;
    const adjustedEndDate = endDate > today ? today : endDate;

    const rangeInDays =
      (adjustedEndDate - startDate) / (1000 * 60 * 60 * 24);

    if (rangeInDays > 91) {
      toast.error('You cannot select a date range of more than Three months.');
      setState(defaultState);
      return;
    }

    setState([
      {
        ...item.selection,
        startDate,
        endDate: adjustedEndDate,
      },
    ]);
  };

  const handleSubmit = () => {
    const selectedRange = state[0];
    const rangeInDays =
      (selectedRange.endDate - selectedRange.startDate) / (1000 * 60 * 60 * 24);

    if (rangeInDays > 91) {
      toast.error('You cannot select a date range of more than Three months.');
      setState(defaultState); 
      return;
    }

    onSubmit(selectedRange);
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div className="date-picker-container">
      <DateRangePicker
        ranges={state}
        onChange={handleDateChange}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        direction="horizontal"
        className="responsive-calendar"
        maxDate={today}
      />
      <div className="button-row">
        <button onClick={handleCancel} className="cancel-button">
          {TextConstants.cancel}
        </button>
        <button onClick={handleSubmit} className="submit-button">
          {TextConstants.submit}
        </button>
      </div>
    </div>
  );
};

export default DatePicker;
